import React, { useState } from "react";
import {
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  Row,
} from "reactstrap";
import { editReservationAmount } from "../../../api/reservation";
import { useResponse } from "../../../hooks/useResponse";
import ResultHandler from "../../../components/ResultHandler";

const EditReservationAmountModal = ({
  reservation,
  show,
  handleClose,
  handleRefetch,
}) => {
  const [amountVal, setAmountVal] = useState(reservation?.amount || "");

  const { loading, error, setData } = useResponse(editReservationAmount, () => {
    handleClose();
    handleRefetch();
  });

  function handleConfirm() {
    setData({ type: "edit", id: reservation?.id, data: { amount: amountVal } });
  }

  return (
    <Modal isOpen={show} toggle={handleClose} centered={true}>
      <ModalBody className="py-5 px-5">
        <Row>
          <Col lg={12}>
            <div className="text-center">
              <h3 className="text-capitalize">Edit Reservation Amount</h3>
            </div>
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <FormGroup className="mt-3">
              <Label>Amount E</Label>
              <Input
                type="text"
                value={amountVal}
                onChange={(e) => setAmountVal(e.target.value)}
              />
            </FormGroup>
          </Col>
          <ResultHandler error={error} />
        </Row>

        <Row>
          <Col>
            <div className="text-center mt-4">
              <button
                type="button"
                className="btn btn-primary btn-lg ms-2"
                onClick={handleConfirm}
                disabled={!amountVal || loading}
              >
                {loading ? "Loading..." : "Edit"}
              </button>

              <button
                type="button"
                className="btn btn-secondary btn-lg ms-2"
                onClick={handleClose}
              >
                Cancel
              </button>
            </div>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default EditReservationAmountModal;
